import React, { useState } from "react";

// COMPONENTS
import KogModalFadeComponent from "@/main/components/modal/ModalFadeComponent";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import Button from "@/main/components/shared/button/button";

// UTILS/SERVICES/MODELS
import { getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { getGuidsQuoteItemInCart } from "@/main/store/cart/cartUtils";
import { CartState } from "@/main/store/cart";

// STYLES & COMPONENTS LOCAL
import * as S from "./styles";

interface IModalConfirmRequoteNationalPartProps {
	openModalConfirm: boolean;
	guidsQuoteItem: string[];
	dataCart: CartState;
	isRequotePartCanceled?: boolean;
	setOpenModalConfirm: React.Dispatch<React.SetStateAction<boolean>>;
	onClickActionConfirm: () => void;
	callbackAfterRequotePart?: () => void;
}
function ModalConfirmRequoteNationalPart({
	guidsQuoteItem,
	dataCart,
	isRequotePartCanceled,
	setOpenModalConfirm,
	onClickActionConfirm,
	callbackAfterRequotePart,
}: IModalConfirmRequoteNationalPartProps) {
	const [isLoadingSave, setIsLoadingSave] = useState<boolean>(false);
	const guidsCart = getGuidsQuoteItemInCart(dataCart);
	const removeGuidsQuoteItem = guidsCart.filter((guid) => !guidsQuoteItem.includes(guid));
	const hasLastPartInCart = removeGuidsQuoteItem.length === 0;

	async function handleOnClickActionConfirm() {
		try {
			setIsLoadingSave(true);
			await onClickActionConfirm();
		} catch (error) {
			console.error(error);
		} finally {
			setIsLoadingSave(false);
			if (!isNullUndefined(callbackAfterRequotePart)) {
				callbackAfterRequotePart();
			}
		}
	}

	const renderMessageConfirmationRequote = () => {
		if (hasLastPartInCart && !isRequotePartCanceled)
			return (
				<S.AreaMessageConfirmation>
					<p>{getTranslateByKey("information.confirmRequotePartCancelQuoteBulk")}</p>
					<p>{getTranslateByKey("information.obsConfirmRequotePartCancelQuoteBulk")}</p>
				</S.AreaMessageConfirmation>
			);
		return (
			<S.AreaMessageConfirmation>
				<p>{getTranslateByKey("information.confirmRequoteOrdered")}</p>
				<p>{getTranslateByKey("information.thisActionIsIrreversible")}</p>
			</S.AreaMessageConfirmation>
		);
	};

	return (
		<S.ContainerModalConfirmation>
			<p>{renderMessageConfirmationRequote()}</p>
			<S.AreaButtons>
				<SecondaryButton
					type="button"
					disabled={isLoadingSave}
					onClick={() => {
						setOpenModalConfirm(false);
					}}
					id="id-searchOrder-button-no"
				>
					{getTranslateByKey("information.no")}
				</SecondaryButton>
				<Button
					id="id-searchOrder-button-yes"
					type="button"
					isLoading={isLoadingSave}
					onClick={() => handleOnClickActionConfirm()}
				>
					{getTranslateByKey("information.yes")}
				</Button>
			</S.AreaButtons>
		</S.ContainerModalConfirmation>
	);
}
function WrapperModalConfirmRequoteOrdered(props: IModalConfirmRequoteNationalPartProps) {
	return (
		<KogModalFadeComponent
			isInModal
			closeByOverlay={false}
			open={props.openModalConfirm}
			setOpen={props.setOpenModalConfirm}
		>
			{props.openModalConfirm ? <ModalConfirmRequoteNationalPart {...props} /> : <div />}
		</KogModalFadeComponent>
	);
}
export default WrapperModalConfirmRequoteOrdered;
